type ApiAction = import('types/api').ApiPayloadAction
type ApiRequestConfig = import('types/api').ApiRequestConfig

export const search = (action: ApiAction): ApiRequestConfig => {
  const { search } = action.payload
  return {
    url: '/users',
    params: { search }
  }
}

export const get = (action: ApiAction): ApiRequestConfig => {
  const { ids } = action.payload
  return {
    url: '/users',
    params: { ids }
  }
}
